import { useEffect } from "react";
import { List, ListItemButton, ListItemText, Stack } from "@mui/material";

export const dialogFeedback = { Content, headline: "Feedback/Bug Report" };

function Content() {
  useEffect(
    () => () =>
      document
        .querySelector(".MuiDialog-root")
        ?.style.removeProperty("display"),
    []
  );

  return (
    <Stack
      spacing={2}
      color="var(--surface-on-color)"
      sx={theme => ({
        "& *": {
          transition: theme.transitions.create("all"),
          ...theme.motion.transition.enterPerm
        }
      })}
    >
      <IssueLinks />
    </Stack>
  );
}

function IssueLinks() {
  const links = [
    {
      label: "Submit feedback on GitHub",
      href: "https://github.com/Bytez-com/docs/issues/new?template=feedback.md"
    },
    {
      label: "Submit a bug report on GitHub",
      href: "https://github.com/Bytez-com/docs/issues/new?template=bug_report.md"
    }
  ];

  return (
    <List>
      {links.map(item => (
        <ListItemButton
          key={item.href}
          component="a"
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            "&:hover": {
              backgroundColor: "rgba(25, 118, 210, 0.08)"
            }
          }}
        >
          <ListItemText
            primary={item.label}
            primaryTypographyProps={{ color: "primary.main" }}
          />
        </ListItemButton>
      ))}
    </List>
  );
}
